import { useState, useMemo, useEffect } from 'react';
import { useAccountsStore } from '@lib/store';
import type { GetAccountsResponse } from '@shared/api';
import { MultiRequisites, Requisites } from '@widgets';
import { Button, ItemsType, Modal, PrintableContent, PrintStyle, PrintType, Select } from '@shared/widgets';
import PrintIcon from '@assets/icons/print2.svg';

interface TopUpMyAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  account?: GetAccountsResponse;
}

export const TopUpMyAccountModal = (props: TopUpMyAccountModalProps) => {
  const accountsStore = useAccountsStore();

  const [account, setAccount] = useState<GetAccountsResponse | undefined>(props.account);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [viewPrintVersion, setViewPrintVersion] = useState<boolean>(false);

  useEffect(() => {
    if (!props.account) return;
    setAccount(props.account);
  }, [props.account]);

  const accountChangeHandler = (account?: ItemsType) => {
    const selectedAccount = accountsStore.data.find((item) => item.Id === account?.value)!;
    setAccount(selectedAccount);
    setCurrentSlide(0);
  };

  const makeSelectData = useMemo(
    () => accountsStore.data?.map((item) => ({ value: item.Id, label: item.Amount, leftLabel: item.Currency })),
    [accountsStore.data],
  );
  const requisites = useMemo(() => {
    return account?.MultiRequisites?.[currentSlide];
  }, [account, currentSlide]);
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title='Top Up My Account'>
      <div className='w-full'>
        <div className='text-xs font-semibold text-[#929292] uppercase'>Account</div>
        <Select items={makeSelectData} double value={account?.Id} onChange={accountChangeHandler} />
        <MultiRequisites requisites={account?.MultiRequisites || []} onSlideChange={setCurrentSlide} />
        <div className='mt-10 flex flex-col gap-6.5'>
          <Button className='h-[56px] gap-2.5' fullWidth onClick={() => setViewPrintVersion(true)}>
            <PrintIcon />
            Print
          </Button>
          <Button className='h-[56px]' fullWidth color='outlined' onClick={props.onClose}>
            Back
          </Button>
        </div>
        <PrintableContent
          title={props.account?.Name}
          print={viewPrintVersion}
          onAfterPrint={() => setViewPrintVersion(false)}
          printStyle={PrintStyle.getStyle(PrintType.Table)}
        >
          <Requisites data={{ ...requisites }} />
        </PrintableContent>
      </div>
    </Modal>
  );
};
